import React from 'react';
import { Icon } from './Icon.js';
export const IconChefHat = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M6 15V21H18V15", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M18 15H6C3.79086 15 2 13.2091 2 11C2 8.79086 3.79086 7 6 7H7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7H18C20.2091 7 22 8.79086 22 11C22 13.2091 20.2091 15 18 15Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChefHat.js.map